<template>
<div class="tw-text-sm font-normal">
  <a class="tw-link" target="_blank" :href="getLink()">
    {{storeAnswer.data.street}}
    <br>
    {{storeAnswer.data.street_2}}
    <br>
    {{storeAnswer.data.city}} {{storeAnswer.data.state}}
    <br>
    {{storeAnswer.data.postal_code}}
  </a>
</div>
</template>
<script>
import mixin from './_mixin_display'
export default {
  mixins: [mixin],
  methods: {
    getLink(){
      const arr= [this.storeAnswer.data.street,
        this.storeAnswer.data.street_2,
        this.storeAnswer.data.city,
        this.storeAnswer.data.state,
        this.storeAnswer.data.postal_code]
          .filter(attr => attr )
      return `https://www.google.com/maps/search/?api=1&query=${encodeURI(arr.join(', '))}`
    }
  }
}
</script>